import React from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'

import experimentsVideo from '../images/experiments-cropped.mp4'
import signalsVideo from '../images/s1-c-540.mp4'
import beamVideo from '../images/beammm.mp4'

const VideoContainer = styled.div`
  width: 100%;
  overflow: hidden;
`

const StyledVideo = styled.video`
  width: 100%;
  transform: scale(1.1);
  opacity: 0.5;
  transition: all 0.5s ease-out;
  &:hover {
    opacity: 1;
  }
`

const ItemGrid = styled.div`
  width: 90%;
  margin: 0 auto 10rem;
  padding: 0 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 30px;
  height: 66vw;
  @media (max-width: 1250px) {
    width: 100%;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr;
    height: auto;
    grid-row-gap: 20px;
  }
`

const AspectRatioBoxInner = styled.div`
  position: relative;
`

const GridImage = styled(Img)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.5;
  transition: all 0.5s ease-out;
  &:hover {
    opacity: 1;
  }
`

const AspectRatioBox = styled.div`
  overflow: hidden;
  height: 0;
  width: 100%;
  padding-bottom: 57.3%;
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
`

const ItemDescription = styled.div`
  height: 120px;
  padding: 1rem 0rem;
  background-color: transparent;

  h2 {
    font-size: 30px;
    margin-bottom: 0.5rem;
    font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
      Arial, sans-serif;
  }

  h3 {
    font-size: 18px;
    font-weight: 500;
    color: #bdbdbd;
    font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
      Arial, sans-serif;
  }
`

class Logo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      logoStatus: 'startState',
    }
  }

  mouseEnterVideo(e) {
    e.currentTarget.play()
  }

  mouseLeaveVideo(e) {
    e.currentTarget.pause()
  }

  render() {
    return (
      <ItemGrid>
        <Item>
          <VideoContainer>
            <StyledVideo
              src={experimentsVideo}
              muted
              loop
              //autoPlay
              onMouseEnter={this.mouseEnterVideo}
              onMouseLeave={this.mouseLeaveVideo}
            />
          </VideoContainer>
          <ItemDescription>
            <h2>Origami Studio – Interaction starters</h2>
            <h3>
              Starter kits for trying out prototyping with high-fidelity
              interactivity.
            </h3>
          </ItemDescription>
        </Item>
        <Item>
          <AspectRatioBox>
            <AspectRatioBoxInner>
              <GridImage fluid={this.props.imageOne} />
            </AspectRatioBoxInner>
          </AspectRatioBox>
          <ItemDescription>
            <h2>Pixel Light</h2>
            <h3>
              Building a minimal, LED-lit light surface for mood lighting.
            </h3>
          </ItemDescription>
        </Item>
        <Item>
          <VideoContainer>
            <StyledVideo
              src={signalsVideo}
              muted
              loop
              //autoPlay
              onMouseEnter={this.mouseEnterVideo}
              onMouseLeave={this.mouseLeaveVideo}
            />
          </VideoContainer>
          <ItemDescription>
            <h2>Signals</h2>
            <h3>Prototyping street indicators for autonomous vehicles.</h3>
          </ItemDescription>
        </Item>
        <Item>
          <VideoContainer>
            <StyledVideo
              src={beamVideo}
              muted
              loop
              //autoPlay
              onMouseEnter={this.mouseEnterVideo}
              onMouseLeave={this.mouseLeaveVideo}
            />
          </VideoContainer>
          <ItemDescription>
            <h2>Dashboard Avatars</h2>
            <h3>
              Exploring social interaction for drivers using VR prototypes and
              driving simulators.
            </h3>
          </ItemDescription>
        </Item>
      </ItemGrid>
    )
  }
}

export default Logo
